<div class="w-auto">
	<div class="offcanvas-header">
		<app-sidebar-logo></app-sidebar-logo>
	</div>
	<div class="offcanvas-body border">
		<app-header-menu></app-header-menu>
	</div>

	<!--begin::Footer-->
	<app-sidebar-footer class="app-sidebar-footer flex-column-auto pt-2 pb-6 px-6" id="kt_app_sidebar_footer">
	</app-sidebar-footer>
	<!--end::Footer-->
</div>